module.exports = __webpack_public_path__ + "img/315.d5223fb3.png";